<h1 mat-dialog-title class="p-2 text-center">Nouveau Substrat</h1>
<div class="">
    <div class="row g-0 p-3 align-items-center">
        <mat-form-field class="col-12">
            <mat-label>Substrat</mat-label>
            <mat-select *ngIf="InterventionType === 1" placeholder="Substrat" [(ngModel)]="SampleTaking.Type" required>
                <mat-option *ngFor="let slm of IBGNSubstratList" [value]="slm.idx">
                    <span>{{slm.s}}</span>
                </mat-option>
            </mat-select>
            <mat-select *ngIf="InterventionType === 2" placeholder="Substrat" [(ngModel)]="SampleTaking.Type" required>
                <mat-option *ngFor="let slm of MPCESubstratList" [value]="slm.idx">
                    <span>{{slm.s}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="col-6">
            <mat-label>Recouvrement</mat-label>
            <input matInput placeholder="Recouvrement" type="number" [(ngModel)]="SampleTaking.Pourcentage" [formControl]="PercentageControl">
        </mat-form-field>
        <mat-checkbox class="col-6 ps-3" (click)="setPresenceForSampleTaking()" [(ngModel)]="SampleTaking.Presence">Présence</mat-checkbox>

        <div *ngFor="let v of VitesseList">
            <div *ngIf="!((v === 2 || v === 4) && InterventionType === 2)" class="row justify-content-center g-0">
                <div class="col-1 align-self-center text-center">
                    <p class="m-0"> N{{v}}</p>
                </div>
                <mat-button-toggle-group class="col-auto" [(ngModel)]="Selection[v - 1]" multiple #group (change)="toggleChange($event, v)">
                    <mat-button-toggle value="1" (click)="checkIfAlreadyPicked(v, 1)">
                        <mat-icon>looks_one</mat-icon>
                    </mat-button-toggle>
                    <mat-button-toggle value="2" (click)="checkIfAlreadyPicked(v, 2)">
                        <mat-icon>looks_two</mat-icon>
                    </mat-button-toggle>
                    <mat-button-toggle value="3" (click)="checkIfAlreadyPicked(v, 3)">
                        <mat-icon>looks_3</mat-icon>
                    </mat-button-toggle>
                    <mat-button-toggle value="4" (click)="checkIfAlreadyPicked(v, 4)">
                        <mat-icon>looks_4</mat-icon>
                    </mat-button-toggle>
                    <mat-button-toggle value="5" (click)="checkIfAlreadyPicked(v, 5)">
                        <mat-icon>looks_5</mat-icon>
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>
    </div>
    <button appPreventDoubleClick class="col-6 squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onCancel()">
        Annuler
    </button>
    <button appPreventDoubleClick class="col-6 squared-flat-button" color="warn" mat-stroked-button (throttledClick)="onConfirm()" [disabled]="!CanAdd">
        Sauvegarder
    </button>

</div>